var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lc-recorder",on:{"click":_vm.handleClick}},[_vm._t("default",null,{"isRecording":_vm.isRecording,"isRecorderInitFinish":_vm.isRecorderInitFinish})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }